import React from "react";
import axios from "axios";
import moment from "moment";
import Cards from "react-credit-cards";
import NotificationSystem from "react-notification-system";
import {
  Card,
  Label,
  Col,
  Row,
  Table,
  Form,
  Input,
  Button,
  CardBody,
  CardHeader,
  ModalHeader,
  Modal,
  ModalBody,
  FormGroup,
  Tooltip,
  UncontrolledCollapse,
} from "reactstrap";
import { IoMdEye } from "react-icons/io";
import { MdEdit, MdClose, MdFileDownload, MdFileUpload } from "react-icons/md";
import {
  BsFillExclamationTriangleFill,
  BsCircleFill,
  BsCheck,
  BsFillQuestionCircleFill,
} from "react-icons/bs";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Select from "react-select";
import Avatar from "../../components/Avatar";
import Page from "../../components/Page";
import userImage from "../../assets/img/user.jpg";
import PageSpinner from "../../components/PageSpinner";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

import { NOTIFICATION_SYSTEM_STYLE } from "../../utils/constants";

import * as Server from "../../Server";
// import DefaultImage from "../../assets/img/defaultUser.png";
import { capitalizeFirstLetter, getAuthUser } from "../../GeneralFunctions";

// let user = {};

class RushUserPlayerDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      child: "",
      player: {},
      currentCamps: [],
      expiredCamps: [],
      showLoader: false,
      viewDefaultImg: true,
      notes: "",
      imageUrl: "",
      fileName: "",
      teams: [],
      firstName: "",
      lastName: "",
      playerEmail: "",
      playerPhone: "",
      birthday: "",
      childNote: "",
      uploadKey: "",
      ImageModel: false,
      selectedFile: "",
      phoneUpdateKey: true,
      birthdayUpdateKey: true,
      lastNameUpdateKey: true,
      firstNameUpdateKey: true,
      dueAmountBreakUpModal: false,
      creditAmountBreakUpModal: false,
      childNoteUpdateKey: true,
      childPhoneUpdateKey: true,
      childEmailUpdateKey: true,
      paymentBalance: 0,
      paymentBalanceBreakUp: [],
      statusTooltip: false,
      cardViewModal: false,
      bankViewModal: false,
      stripeCards: [],
      bankAccounts: [],
      type: "",
      addCardCollapse: false,
      addBankCollapse: false,
      cvc: "",
      name: "",
      number: "",
      expiry: "",
      cardType: "",
      focus: "number",
      routing_number: "",
      account_number: "",
      account_holder_name: "",
      confirm_account_number: "",
      viewError: false,
      allAdultsOptions: [],
      selectedAdult: null,
      adultPhoneUpdateKey: true,
      adultEmailUpdateKey: true,
      adultPhone: "",
      adultEmail: "",
      genderUpdateKey: true,
      addressUpdateKey: true,
      stateUpdateKey: true,
      cityUpdateKey: true,
      zipCodeUpdateKey: true,
      playerGenderSelected: null,
      playerGender: "",
      playerAddress: "",
      playerState: "",
      playerCity: "",
      playerZipCode: "",
    };
  }

  componentDidMount() {
    // user = getAuthUser();
    this.getPlayerDetail({ _id: this.props.history.location.state });
  }

  dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0)
      byteString = atob(dataURI.split(",")[1]);
    else byteString = unescape(dataURI.split(",")[1]);

    // separate out the mime component
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  getPlayerDetail = async (event) => {
    if (!event._id) event.persist();
    try {
      let childId = event._id ? event._id : event.target.value;
      this.setState({
        showLoader: true,
      });
      let response = await Server.request({
        url: "rushsoccer/webapp/player/detail",
        method: "POST",
        data: childId,
        token: "marketplaceAccessToken",
      });
      if (response) {
        let allAdultsOptions = [
          {
            label: `${response.player.data.firstName} ${response.player.data.lastName}`,
            value: response.player._id,
          },
          ...response.player.allAdults.map((allAdult) => ({
            label: `${allAdult.data.firstName} ${allAdult.data.lastName}`,
            value: allAdult._id,
          })),
        ];
        this.setState({
          showLoader: false,
          allAdultsOptions,
          player: response.player,
          child: response.player.child,
          teams: response.player.teams,
          firstName: response.player.child.data.firstName,
          lastName: response.player.child.data.lastName,
          playerPhone: response.player.child.data.playerPhone,
          playerEmail: response.player.child.data.playerEmail,
          birthday: response.player.child.data.birthday,
          childNote: response.player.child.notes,
          viewDefaultImg: response.player.child.data.files.find(
            (file) => file.name === "photo"
          )
            ? false
            : true,
          currentCamps: response.player.child.camps.filter(
            (camp) =>
              (camp.subscriptionsExpiredAt === null &&
                (camp.paymentStatus === "paid" ||
                  camp.paymentStatus === "pending")) ||
              (new Date(camp.subscriptionsExpiredAt).getTime() >
                new Date().getTime() &&
                (camp.paymentStatus === "paid" ||
                  camp.paymentStatus === "pending"))
          ),
          expiredCamps: response.player.child.camps.filter(
            (camp) =>
              (camp.subscriptionsExpiredAt !== null &&
                new Date(camp.subscriptionsExpiredAt).getTime() <
                  new Date().getTime()) ||
              (camp.paymentStatus !== "paid" &&
                camp.paymentStatus !== "pending")
          ),
          paymentBalance: response.player.child.paymentBalance,
          paymentBalanceBreakUp: response.player.child.paymentBalanceBreakUp.reverse(),
          stripeCards: response.player.allCreditCards,
          bankAccounts: response.player.allBankAccounts,
          adultEmail: response.player.data.email,
          adultPhone: response.player.data.username,
          playerGender: response.player.child.data.gender,
          playerAddress: response.player.child.data.address,
          playerState: response.player.child.data.state,
          playerCity: response.player.child.data.city,
          playerZipCode: response.player.child.data.zipcode,
          playerGenderSelected: response.player.child.data.gender
            ? response.player.child.data.gender === "male"
              ? {
                  label: "Male",
                  value: "male",
                }
              : response.player.child.data.gender === "female"
              ? {
                  label: "Female",
                  value: "female",
                }
              : {}
            : {},
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  renderPlayerPaymentDetailPage = async (camp, status) => {
    Object.assign(camp, { status: status });
    this.props.history.push({
      pathname: "/rushUserPaymentDetails",
      state: {
        camp,
        playerName: `${this.state.child.data.firstName} ${this.state.child.data.lastName}`,
      },
    });
  };

  updateAdultInfo = async (event, type) => {
    event.preventDefault();
    if (type === "adultPhone" && this.state.adultPhone.length < 10) {
      return this.notificationSystem.addNotification({
        message: "Please enter phone 10 digit",
        level: "error",
      });
    }
    let data = {
      parentId: this.state.player._id,
    };
    if (type === "adultPhone") {
      Object.assign(data, {
        update: type,
        oldPhoneNumber: this.state.player.data.username,
        newPhoneNumber: this.state.adultPhone,
      });
      if (data.oldPhoneNumber === data.newPhoneNumber) return;
    }
    if (type === "adultEmail")
      Object.assign(data, {
        update: type,
        email: this.state.adultEmail,
        username: this.state.player.data.username,
      });
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "rushUser/webapp/updateAdultPhoneEmail",
        method: "POST",
        data,
      });
      if (response && response.success) {
        this.setState({ showLoader: false, adultEmail: "", adultPhone: "" });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getPlayerDetail({ _id: this.props.history.location.state });
      } else {
        this.setState({
          showLoader: false,
          adultEmail: this.state.player.data.email,
          adultPhone: this.state.player.data.username,
        });
      }
    } catch (error) {
      this.setState({
        showLoader: false,
        adultEmail: this.state.player.data.email,
        adultPhone: this.state.player.data.username,
      });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updatePlayerInfo = async (event, key, name, fileName) => {
    event.preventDefault();
    if (key === "parent" && this.state.player.data.phone.length < 10) {
      return this.notificationSystem.addNotification({
        message: "Please enter phone 10 digit",
        level: "error",
      });
    }
    let formData = new FormData();
    formData.append("registerFor", key);
    formData.append("parentId", this.state.player._id);
    formData.append("childId", this.state.child._id);
    name.length > 0 && formData.append(name, this.state.child.data[name]);
    name === "playerPhone" &&
      formData.append("username", this.state.child.data[name]);
    this.state.selectedFile &&
      formData.append(fileName, this.state.selectedFile);
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "rushUser/webapp/user/update",
        method: "POST",
        data: formData,
      });
      if (response) {
        this.setState({ showLoader: false, selectedFile: "", uploadKey: "" });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getPlayerDetail({ _id: this.props.history.location.state });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
    name === "playerPhone" &&
      this.setState((prevState) => ({
        child: {
          ...prevState.child,
          data: {
            ...prevState.child.data,
            playerPhone: this.state.playerPhone,
          },
        },
      }));
    name === "playerEmail" &&
      this.setState((prevState) => ({
        child: {
          ...prevState.child,
          data: {
            ...prevState.child.data,
            playerEmail: this.state.playerEmail,
          },
        },
      }));
    key === "parent" &&
      this.setState({
        phoneUpdateKey: !this.state.phoneUpdateKey,
      });
  };

  updatePlayer = async (event, key) => {
    event.preventDefault();
    let data = {
      childId: this.state.child._id,
      parentId: this.state.player._id,
    };
    data[key] = this.state.child[key];
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "rushUser/webapp/child/update",
        method: "POST",
        data,
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getPlayerDetail({ _id: this.props.history.location.state });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  downloadImage = async (event, file) => {
    event.preventDefault();
    this.setState({ showLoader: true });
    try {
      let response = await axios({
        url: file.url,
        method: "GET",
        responseType: "blob",
      });
      if (response) {
        this.setState({ showLoader: false });
        let url = window.URL.createObjectURL(new Blob([response.data]));
        let link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${this.state.child.data.firstName}_${file.name}.jpg`
        );
        document.body.appendChild(link);
        link.click();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  addCreditCard = async (event) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      if (!this.state.selectedAdult) throw Error("Select the adult");
      let response = await Server.request({
        url: "rushsoccer/addPaymentMethod",
        method: "POST",
        data: {
          type: "card",
          APIVersion: "v2",
          parentId: this.state.selectedAdult.value,
          cvc: this.state.cvc,
          number: this.state.number,
          exp_year: this.state.expiry.length
            ? this.state.expiry.substring(2, 4)
            : "",
          exp_month: this.state.expiry.length
            ? this.state.expiry.substring(0, 2)
            : "",
          cardType: this.state.cardType,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          cvc: "",
          name: "",
          number: "",
          expiry: "",
          cardType: "",
          focus: "number",
          addCardCollapse: false,
        });
        this.getPlayerDetail({ _id: this.props.history.location.state });
        this.toggleCardViewModal();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  addBankAccount = async (event) => {
    event.preventDefault();
    try {
      if (this.state.account_number !== this.state.confirm_account_number) {
        throw Error("Your account numbers don't match.");
      }
      if (!this.state.selectedAdult) throw Error("Select the adult");
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/addPaymentMethod",
        method: "POST",
        data: {
          type: "bank_account",
          APIVersion: "v2",
          parentId: this.state.selectedAdult.value,
          routing_number: this.state.routing_number,
          account_number: this.state.account_number,
          account_holder_name: this.state.account_holder_name,
          confirm_account_number: this.state.confirm_account_number,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          routing_number: "",
          account_number: "",
          account_holder_name: "",
          confirm_account_number: "",
          addBankCollapse: false,
        });
        this.getPlayerDetail({ _id: this.props.history.location.state });
        this.toggleBankViewModal();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  toggleImageModel = (event, imageUrl) => {
    event.preventDefault();
    this.setState({
      ImageModel: !this.state.ImageModel,
      imageUrl: imageUrl,
    });
  };

  toggleCardViewModal = () => {
    this.setState({
      cardViewModal: !this.state.cardViewModal,
      selectedAdult: null,
    });
  };

  toggleBankViewModal = () => {
    this.setState({
      bankViewModal: !this.state.bankViewModal,
      selectedAdult: null,
    });
  };

  toggleDueAmountBreakUpModal = () => {
    this.setState({
      dueAmountBreakUpModal: !this.state.dueAmountBreakUpModal,
    });
  };

  toggleCreditAmountBreakUpModal = () => {
    this.setState({
      creditAmountBreakUpModal: !this.state.creditAmountBreakUpModal,
    });
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page
          title="Player Detail"
          breadcrumbs={[{ name: "Player Detail", active: true }]}
        >
          <Row>
            <Col>
              <Card className="mb-3">
                <CardHeader>
                  <Row className="playerDetailRow">
                    <Col xl={3} lg={3} md={3}>
                      {this.state.viewDefaultImg ? (
                        <Avatar
                          style={{ marginRight: "10px" }}
                          className="profileImg"
                          src={userImage}
                        />
                      ) : (
                        <img
                          className="profileImg"
                          alt=""
                          src={
                            this.state.child.data.files.find(
                              (file) => file.name === "photo"
                            ).url
                          }
                        ></img>
                      )}
                    </Col>
                    <Col xl={9} lg={9} md={9}>
                      <Row
                        style={{
                          marginBottom: "10px",
                          borderBottom: "2px solid #17517b",
                        }}
                      >
                        <Col xl={7} lg={7} md={7}>
                          <h1>
                            {this.state.child.data &&
                              this.state.child.data.firstName}{" "}
                            {this.state.child.data &&
                              this.state.child.data.lastName}
                          </h1>
                        </Col>
                      </Row>
                      <Row>
                        <Col xl={12} lg={12} md={12}>
                          <Row>
                            <Col xl={4} lg={4} md={4}>
                              <strong>First Name</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.firstNameUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.child
                                        ? this.state.child.data.firstName
                                        : ""
                                    }
                                    className="w-50"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState((prevState) => ({
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            firstName: event.target.value,
                                          },
                                        },
                                      }));
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayerInfo(
                                        event,
                                        "child",
                                        "firstName"
                                      );
                                      this.setState({
                                        firstNameUpdateKey: !this.state
                                          .firstNameUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState((prevState) => ({
                                        firstNameUpdateKey: !this.state
                                          .firstNameUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            firstName: this.state.firstName,
                                          },
                                        },
                                      }));
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.firstNameUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.child.data
                                      ? this.state.child.data.firstName
                                      : "-"}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        firstNameUpdateKey: !this.state
                                          .firstNameUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Last Name</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.lastNameUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.child
                                        ? this.state.child.data.lastName
                                        : ""
                                    }
                                    className="w-50"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState((prevState) => ({
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            lastName: event.target.value,
                                          },
                                        },
                                      }));
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayerInfo(
                                        event,
                                        "child",
                                        "lastName"
                                      );
                                      this.setState({
                                        lastNameUpdateKey: !this.state
                                          .lastNameUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) =>
                                      this.setState((prevState) => ({
                                        lastNameUpdateKey: !this.state
                                          .lastNameUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            lastName: this.state.lastName,
                                          },
                                        },
                                      }))
                                    }
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.lastNameUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.child.data
                                      ? this.state.child.data.lastName
                                      : "-"}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        lastNameUpdateKey: !this.state
                                          .lastNameUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Parent Phone</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.adultPhoneUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.adultPhone
                                        ? this.state.adultPhone
                                        : ""
                                    }
                                    className="w-50"
                                    maxLength="10"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState({
                                        adultPhone: event.target.value,
                                      });
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updateAdultInfo(event, "adultPhone");
                                      this.setState({
                                        adultPhoneUpdateKey: !this.state
                                          .adultPhoneUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState({
                                        adultPhoneUpdateKey: !this.state
                                          .adultPhoneUpdateKey,
                                        adultPhone: this.state.player.data
                                          ? this.state.player.data.username ||
                                            ""
                                          : "",
                                      });
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.adultPhoneUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.adultPhone
                                      ? this.state.adultPhone || "-"
                                      : "-"}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        adultPhoneUpdateKey: !this.state
                                          .adultPhoneUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Parent Email</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.adultEmailUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.adultEmail
                                        ? this.state.adultEmail
                                        : ""
                                    }
                                    className="w-50"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState({
                                        adultEmail: event.target.value,
                                      });
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updateAdultInfo(event, "adultEmail");
                                      this.setState({
                                        adultEmailUpdateKey: !this.state
                                          .adultEmailUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState({
                                        adultEmailUpdateKey: !this.state
                                          .adultEmailUpdateKey,
                                        adultEmail: this.state.player.data
                                          ? this.state.player.data.email || ""
                                          : "",
                                      });
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.adultEmailUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.adultEmail
                                      ? this.state.adultEmail || "-"
                                      : "-"}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        adultEmailUpdateKey: !this.state
                                          .adultEmailUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Player Phone</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.childPhoneUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.child
                                        ? this.state.child.data.playerPhone
                                        : ""
                                    }
                                    className="w-50"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState((prevState) => ({
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            playerPhone: event.target.value,
                                          },
                                        },
                                      }));
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayerInfo(
                                        event,
                                        "child",
                                        "playerPhone"
                                      );
                                      this.setState({
                                        childPhoneUpdateKey: !this.state
                                          .childPhoneUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState((prevState) => ({
                                        childPhoneUpdateKey: !this.state
                                          .childPhoneUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            playerPhone: this.state.playerPhone,
                                          },
                                        },
                                      }));
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.childPhoneUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.child.data
                                      ? this.state.child.data.playerPhone || "-"
                                      : "-"}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        childPhoneUpdateKey: !this.state
                                          .childPhoneUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Player Email</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.childEmailUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.child
                                        ? this.state.child.data.playerEmail
                                        : ""
                                    }
                                    className="w-50"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState((prevState) => ({
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            playerEmail: event.target.value,
                                          },
                                        },
                                      }));
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayerInfo(
                                        event,
                                        "child",
                                        "playerEmail"
                                      );
                                      this.setState({
                                        childEmailUpdateKey: !this.state
                                          .childEmailUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState((prevState) => ({
                                        childEmailUpdateKey: !this.state
                                          .childEmailUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            playerEmail: this.state.playerEmail,
                                          },
                                        },
                                      }));
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.childEmailUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.child.data
                                      ? this.state.child.data.playerEmail || "-"
                                      : "-"}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        childEmailUpdateKey: !this.state
                                          .childEmailUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Date of Birth</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.birthdayUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="date"
                                    value={
                                      this.state.child
                                        ? new Date(
                                            this.state.child.data.birthday
                                          )
                                            .toISOString()
                                            .substr(0, 10)
                                        : ""
                                    }
                                    className="w-50"
                                    onChange={(event) => {
                                      event.persist();
                                      event.target.value !== "" &&
                                        this.setState((prevState) => ({
                                          child: {
                                            ...prevState.child,
                                            data: {
                                              ...prevState.child.data,
                                              birthday: event.target.value,
                                            },
                                          },
                                        }));
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayerInfo(
                                        event,
                                        "child",
                                        "birthday"
                                      );
                                      this.setState({
                                        birthdayUpdateKey: !this.state
                                          .birthdayUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      event.persist();
                                      this.setState((prevState) => ({
                                        birthdayUpdateKey: !this.state
                                          .birthdayUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            birthday: this.state.birthday,
                                          },
                                        },
                                      }));
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.birthdayUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {(this.state.child.data &&
                                      moment
                                        .utc(this.state.child.data.birthday)
                                        .format("LL")) ||
                                      "-"}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        birthdayUpdateKey: !this.state
                                          .birthdayUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Gender</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.genderUpdateKey === false && (
                                <div className="d-flex">
                                  <Select
                                    options={[
                                      {
                                        label: "Male",
                                        value: "male",
                                      },
                                      {
                                        label: "Female",
                                        value: "female",
                                      },
                                    ]}
                                    value={this.state.playerGenderSelected}
                                    onChange={(result) => {
                                      this.setState((prevState) => ({
                                        playerGenderSelected: result,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            gender: result.value,
                                          },
                                        },
                                      }));
                                    }}
                                    className="w-50 basic-single"
                                  />
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayerInfo(
                                        event,
                                        "child",
                                        "gender"
                                      );
                                      this.setState({
                                        genderUpdateKey: !this.state
                                          .genderUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState((prevState) => ({
                                        genderUpdateKey: !this.state
                                          .genderUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            gender: this.state.playerGender,
                                          },
                                        },
                                      }));
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.genderUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.child
                                      ? this.state.child.data.gender || "-"
                                      : ""}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        genderUpdateKey: !this.state
                                          .genderUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Address</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.addressUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.child
                                        ? this.state.child.data.address
                                        : ""
                                    }
                                    className="w-50"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState((prevState) => ({
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            address: event.target.value,
                                          },
                                        },
                                      }));
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayerInfo(
                                        event,
                                        "child",
                                        "address"
                                      );
                                      this.setState({
                                        addressUpdateKey: !this.state
                                          .addressUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState((prevState) => ({
                                        addressUpdateKey: !this.state
                                          .addressUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            address: this.state.playerAddress,
                                          },
                                        },
                                      }));
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.addressUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.child
                                      ? this.state.child.data.address || "-"
                                      : ""}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        addressUpdateKey: !this.state
                                          .addressUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>State</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.stateUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.child
                                        ? this.state.child.data.state
                                        : ""
                                    }
                                    className="w-50"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState((prevState) => ({
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            state: event.target.value,
                                          },
                                        },
                                      }));
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayerInfo(
                                        event,
                                        "child",
                                        "state"
                                      );
                                      this.setState({
                                        stateUpdateKey: !this.state
                                          .stateUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState((prevState) => ({
                                        stateUpdateKey: !this.state
                                          .stateUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            state: this.state.playerState,
                                          },
                                        },
                                      }));
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.stateUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.child
                                      ? this.state.child.data.state || "-"
                                      : ""}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        stateUpdateKey: !this.state
                                          .stateUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>City</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.cityUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.child
                                        ? this.state.child.data.city
                                        : ""
                                    }
                                    className="w-50"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState((prevState) => ({
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            city: event.target.value,
                                          },
                                        },
                                      }));
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayerInfo(
                                        event,
                                        "child",
                                        "city"
                                      );
                                      this.setState({
                                        cityUpdateKey: !this.state
                                          .cityUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState((prevState) => ({
                                        cityUpdateKey: !this.state
                                          .cityUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            city: this.state.playerCity,
                                          },
                                        },
                                      }));
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.cityUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.child
                                      ? this.state.child.data.city || "-"
                                      : ""}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        cityUpdateKey: !this.state
                                          .cityUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>ZipCode</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.zipCodeUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.child
                                        ? this.state.child.data.zipcode
                                        : ""
                                    }
                                    className="w-50"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState((prevState) => ({
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            zipcode: event.target.value,
                                          },
                                        },
                                      }));
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayerInfo(
                                        event,
                                        "child",
                                        "zipcode"
                                      );
                                      this.setState({
                                        zipCodeUpdateKey: !this.state
                                          .zipCodeUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState((prevState) => ({
                                        zipCodeUpdateKey: !this.state
                                          .zipCodeUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          data: {
                                            ...prevState.child.data,
                                            zipcode: this.state.playerZipCode,
                                          },
                                        },
                                      }));
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.zipCodeUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.child
                                      ? this.state.child.data.zipcode || "-"
                                      : ""}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        zipCodeUpdateKey: !this.state
                                          .zipCodeUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Past Due</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              <div className="d-flex">
                                <p>
                                  {(this.state.child &&
                                    Number(this.state.child.dueAmount).toFixed(
                                      2
                                    )) ||
                                    "0"}
                                </p>
                                <IoMdEye
                                  size="20px"
                                  className="ml-2"
                                  style={{
                                    cursor: "pointer",
                                    marginTop: "2px",
                                  }}
                                  onClick={this.toggleDueAmountBreakUpModal}
                                ></IoMdEye>
                              </div>
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Credit Balance</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              <div className="d-flex">
                                <p>
                                  {(this.state.child &&
                                    Number(
                                      this.state.child.creditAmount
                                    ).toFixed(2)) ||
                                    "0"}
                                </p>
                                <IoMdEye
                                  size="20px"
                                  className="ml-2"
                                  style={{
                                    cursor: "pointer",
                                    marginTop: "2px",
                                  }}
                                  onClick={this.toggleCreditAmountBreakUpModal}
                                ></IoMdEye>
                              </div>
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Registration Date</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              <p>
                                {(this.state.child &&
                                  moment
                                    .utc(this.state.child.createdAt)
                                    .format("LL")) ||
                                  "-"}
                              </p>
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Credit Card on file</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              <p>
                                {(this.state.player &&
                                  this.state.player.creditCardAdded) ||
                                  "-"}
                                <IoMdEye
                                  size="20px"
                                  className="ml-2"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={this.toggleCardViewModal}
                                ></IoMdEye>
                              </p>
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Bank Account on file</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              <p>
                                {(this.state.player &&
                                  this.state.player.bankAccountAdded) ||
                                  "-"}
                                <IoMdEye
                                  size="20px"
                                  className="ml-2"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={this.toggleBankViewModal}
                                ></IoMdEye>
                              </p>
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Note</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              {this.state.childNoteUpdateKey === false && (
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={
                                      this.state.child
                                        ? this.state.child.notes
                                        : ""
                                    }
                                    className="w-50 mb-2"
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState((prevState) => ({
                                        child: {
                                          ...prevState.child,
                                          notes: event.target.value,
                                        },
                                      }));
                                    }}
                                  ></Input>
                                  <BsCheck
                                    onClick={(event) => {
                                      this.updatePlayer(event, "notes");
                                      this.setState({
                                        childNoteUpdateKey: !this.state
                                          .childNoteUpdateKey,
                                      });
                                    }}
                                    className="ml-2"
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></BsCheck>
                                  <MdClose
                                    onClick={(event) => {
                                      this.setState((prevState) => ({
                                        childNoteUpdateKey: !this.state
                                          .childNoteUpdateKey,
                                        child: {
                                          ...prevState.child,
                                          notes: this.state.childNote,
                                        },
                                      }));
                                    }}
                                    className="ml-3 "
                                    style={{
                                      cursor: "pointer",
                                      margin: "auto 0px",
                                    }}
                                    size="30px"
                                  ></MdClose>
                                </div>
                              )}
                              {this.state.childNoteUpdateKey === true && (
                                <div className="d-flex">
                                  <p>
                                    {this.state.child && this.state.child.notes
                                      ? this.state.child.notes
                                      : "-"}
                                  </p>
                                  <MdEdit
                                    onClick={(event) => {
                                      this.setState({
                                        childNoteUpdateKey: !this.state
                                          .childNoteUpdateKey,
                                      });
                                    }}
                                    className="ml-2 "
                                    style={{ cursor: "pointer" }}
                                    size="20px"
                                  ></MdEdit>
                                </div>
                              )}
                            </Col>
                            <Col xl={4} lg={4} md={4}>
                              <strong>Team Names</strong>
                            </Col>
                            <Col xl={8} lg={8} md={8}>
                              <p>
                                {this.state.teams.length
                                  ? this.state.teams.map((team, index) => (
                                      <div key={index}>{team.name}</div>
                                    ))
                                  : "-"}
                              </p>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="playerDetailRow">
                    <Col xl={12} lg={12} md={12}>
                      <Row
                        style={{
                          marginBottom: "10px",
                          borderBottom: "2px solid #17517b",
                        }}
                      >
                        <Col xs={6}>
                          <h3>Family Detail</h3>
                        </Col>
                      </Row>
                    </Col>
                    <Col xl={12} lg={12} md={12}>
                      <Tabs id="tab1">
                        <TabList>
                          <Tab>Parent 1</Tab>
                          {this.state.player.allAdults &&
                          this.state.player.allAdults.length
                            ? this.state.player.allAdults.map(
                                (adult, index) => (
                                  <Tab key={index}>Parent {index + 2}</Tab>
                                )
                              )
                            : null}
                        </TabList>
                        <TabPanel>
                          <Row>
                            <Col xl={6} lg={6} md={6}>
                              <strong>First Name</strong>
                            </Col>
                            <Col xl={6} lg={6} md={6}>
                              <p className="capitalizeText">
                                {this.state.player.data &&
                                  this.state.player.data.firstName}
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={6} lg={6} md={6}>
                              <strong>Last Name</strong>
                            </Col>
                            <Col xl={6} lg={6} md={6}>
                              <p className="capitalizeText">
                                {this.state.player.data &&
                                  this.state.player.data.lastName}
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={6} lg={6} md={6}>
                              <strong>Phone</strong>
                            </Col>
                            <Col xl={6} lg={6} md={6}>
                              <p className="capitalizeText">
                                {this.state.player.data &&
                                this.state.player.data.phone
                                  ? this.state.player.data.phone
                                  : "-"}
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={6} lg={6} md={6}>
                              <strong>Email</strong>
                            </Col>
                            <Col xl={6} lg={6} md={6}>
                              <p className="lowercaseText">
                                {this.state.player.data &&
                                this.state.player.data.email
                                  ? this.state.player.data.email
                                  : "-"}
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={6} lg={6} md={6}>
                              <strong>RelationShip With Child</strong>
                            </Col>
                            <Col xl={6} lg={6} md={6}>
                              <p className="capitalizeText">
                                {this.state.player.data &&
                                this.state.player.data.relationShipWithChild
                                  ? this.state.player.data.relationShipWithChild
                                  : "-"}
                              </p>
                            </Col>
                          </Row>
                        </TabPanel>
                        {this.state.player.allAdults &&
                        this.state.player.allAdults.length
                          ? this.state.player.allAdults.map((adult, index) => (
                              <TabPanel key={index}>
                                <Row>
                                  <Col xl={6} lg={6} md={6}>
                                    <strong>First Name</strong>
                                  </Col>
                                  <Col xl={6} lg={6} md={6}>
                                    <p className="capitalizeText">
                                      {adult.data && adult.data.firstName
                                        ? adult.data.firstName
                                        : "-"}
                                    </p>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xl={6} lg={6} md={6}>
                                    <strong>Last Name</strong>
                                  </Col>
                                  <Col xl={6} lg={6} md={6}>
                                    <p className="capitalizeText">
                                      {adult.data && adult.data.lastName
                                        ? adult.data.lastName
                                        : "-"}
                                    </p>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xl={6} lg={6} md={6}>
                                    <strong>Phone</strong>
                                  </Col>
                                  <Col xl={6} lg={6} md={6}>
                                    <p className="capitalizeText">
                                      {adult.data && adult.data.phone
                                        ? adult.data.phone
                                        : "-"}
                                    </p>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xl={6} lg={6} md={6}>
                                    <strong>Email</strong>
                                  </Col>
                                  <Col xl={6} lg={6} md={6}>
                                    <p className="lowercaseText">
                                      {adult.data && adult.data.email
                                        ? adult.data.email
                                        : "-"}
                                    </p>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xl={6} lg={6} md={6}>
                                    <strong>RelationShip With Child</strong>
                                  </Col>
                                  <Col xl={6} lg={6} md={6}>
                                    <p className="capitalizeText">
                                      {adult.data &&
                                      adult.data.relationShipWithChild
                                        ? adult.data.relationShipWithChild
                                        : "-"}
                                    </p>
                                  </Col>
                                </Row>
                              </TabPanel>
                            ))
                          : null}
                      </Tabs>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Image</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {typeof this.state.child === "object" &&
                          this.state.child !== null
                            ? this.state.child.data.files.map((file, index) => (
                                <tr key={index}>
                                  <td
                                    onClick={(e) =>
                                      this.toggleImageModel(e, file.url)
                                    }
                                  >
                                    <img
                                      src={file.url}
                                      className="img-responsive"
                                      alt=""
                                      style={{ width: "150px" }}
                                    />
                                  </td>
                                  <td>{file.status}</td>
                                  <td>
                                    <div className="d-flex">
                                      <Button
                                        className="ml-3"
                                        onClick={(event) =>
                                          this.downloadImage(event, file)
                                        }
                                      >
                                        <MdFileDownload size="20px"></MdFileDownload>
                                      </Button>
                                      <Button
                                        className="p-0 ml-3"
                                        style={{
                                          width: "45px",
                                          height: "40px",
                                        }}
                                      >
                                        <Label
                                          htmlFor={
                                            file.name === "photo"
                                              ? "photo"
                                              : "birthCertificate"
                                          }
                                          className="w-100 h-100 mt-2"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <MdFileUpload size="21px"></MdFileUpload>
                                        </Label>
                                      </Button>
                                      <Input
                                        id={
                                          file.name === "photo"
                                            ? "photo"
                                            : "birthCertificate"
                                        }
                                        style={{ display: "none" }}
                                        type="file"
                                        accept="image/*"
                                        onChange={(event) => {
                                          this.setState({
                                            selectedFile: event.target.files[0],
                                            uploadKey:
                                              file.name === "photo"
                                                ? "photo"
                                                : "birthCertificate",
                                          });
                                        }}
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <div className="d-flex">
                                      <Label className="m-0 p-0">
                                        {this.state.selectedFile &&
                                        file.name === this.state.uploadKey
                                          ? this.state.selectedFile.name
                                          : ""}
                                      </Label>
                                      {this.state.selectedFile &&
                                      file.name === this.state.uploadKey ? (
                                        <div className="ml-3">
                                          <Label
                                            className="mr-3"
                                            onClick={(event) =>
                                              this.updatePlayerInfo(
                                                event,
                                                "child",
                                                "",
                                                file.name
                                              )
                                            }
                                            style={{
                                              cursor: "pointer",
                                            }}
                                          >
                                            <BsCheck size="30px"></BsCheck>
                                          </Label>
                                          <Label
                                            onClick={() =>
                                              this.setState({
                                                selectedFile: "",
                                              })
                                            }
                                            style={{
                                              cursor: "pointer",
                                            }}
                                          >
                                            <MdClose size="30px"></MdClose>
                                          </Label>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              ))
                            : ""}
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Row
                    className="playerDetailRow"
                    style={{ background: "white" }}
                  >
                    <Tabs style={{ width: "100%" }}>
                      <TabList>
                        <Tab>Current Registrations</Tab>
                        <Tab>Past Registrations</Tab>
                        <Tab>Payment Balance History</Tab>
                      </TabList>
                      <TabPanel>
                        <Table striped hover responsive>
                          <thead>
                            <tr>
                              <th>Event Name</th>
                              <th>State</th>
                              <th>Registration</th>
                              <th>Payment Status</th>
                              <th>Price</th>
                              <th>Notes</th>
                              <th>View Transaction</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.currentCamps.length > 0 ? (
                              this.state.currentCamps.map((camp, index) => (
                                <tr key={index}>
                                  <td>
                                    {capitalizeFirstLetter(camp.campName)}
                                  </td>
                                  <td>
                                    {new Date().getTime() >
                                      new Date(
                                        camp.subscriptionsStartedAt
                                      ).getTime() ||
                                    new Date().setHours(12, 0, 0, 0) ===
                                      new Date(
                                        camp.subscriptionsStartedAt
                                      ).setHours(12, 0, 0, 0) ? (
                                      <BsCircleFill color="#0cf10c"></BsCircleFill>
                                    ) : (
                                      <BsCircleFill></BsCircleFill>
                                    )}
                                  </td>
                                  <td>
                                    {moment.utc(camp.createdAt).format("LL")}
                                  </td>
                                  <td>
                                    {capitalizeFirstLetter(camp.paymentStatus)}
                                  </td>
                                  <td>{camp.price.toFixed(2)}</td>
                                  <td>
                                    {camp.notes
                                      ? capitalizeFirstLetter(camp.notes)
                                      : "-"}
                                  </td>
                                  <td
                                    style={{
                                      cursor: "pointer",
                                      color: "blue",
                                    }}
                                    onClick={() =>
                                      this.renderPlayerPaymentDetailPage(
                                        camp,
                                        "active"
                                      )
                                    }
                                  >
                                    View
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="12" className="text-center">
                                  No events found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </TabPanel>
                      <TabPanel>
                        <Table striped hover responsive>
                          <thead>
                            <tr>
                              <th>Event Name</th>
                              <th>State</th>
                              <th>Registration</th>
                              <th>Payment Status</th>
                              <th>Price</th>
                              <th>Notes</th>
                              <th>View Transaction</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.expiredCamps.length > 0 ? (
                              this.state.expiredCamps.map((camp, index) => (
                                <tr key={index}>
                                  <td>
                                    {capitalizeFirstLetter(camp.campName)}
                                  </td>
                                  <td>
                                    <BsCircleFill></BsCircleFill>
                                  </td>
                                  <td>
                                    {moment.utc(camp.createdAt).format("LL")}
                                  </td>
                                  <td>
                                    {capitalizeFirstLetter(camp.paymentStatus)}
                                  </td>
                                  <td>{camp.price.toFixed(2)}</td>
                                  <td>
                                    {camp.notes
                                      ? capitalizeFirstLetter(camp.notes)
                                      : "-"}
                                  </td>
                                  <td
                                    style={{
                                      cursor: "pointer",
                                      color: "blue",
                                    }}
                                    onClick={() =>
                                      this.renderPlayerPaymentDetailPage(
                                        camp,
                                        "inactive"
                                      )
                                    }
                                  >
                                    View
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="12" className="text-center">
                                  No events found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </TabPanel>
                      <TabPanel>
                        <Table striped hover responsive>
                          <thead>
                            <tr>
                              <th style={{ width: "50%", textAlign: "center" }}>
                                Payment Balance
                              </th>
                              <th>
                                $
                                {this.state.paymentBalance
                                  ? this.state.paymentBalance.toFixed(2)
                                  : "0"}
                              </th>
                            </tr>
                          </thead>
                        </Table>
                        <Table striped hover responsive>
                          <thead>
                            <tr>
                              <th>Amount</th>
                              <th>Note</th>
                              <th>Date</th>
                              <th>
                                Status
                                <BsFillQuestionCircleFill
                                  size="15px"
                                  id="statusTooltip"
                                  style={{
                                    margin: "auto auto auto 5px",
                                    outline: " unset",
                                    cursor: "pointer",
                                  }}
                                  onMouseOver={() =>
                                    this.setState({
                                      statusTooltip: true,
                                    })
                                  }
                                  onMouseOut={() =>
                                    this.setState({
                                      statusTooltip: false,
                                    })
                                  }
                                />
                                <Tooltip
                                  placement={
                                    this.state.paymentBalanceBreakUp.length
                                      ? "bottom"
                                      : "right"
                                  }
                                  isOpen={this.state.statusTooltip}
                                  target="statusTooltip"
                                  toggle={() => {}}
                                >
                                  Credit - Amount credited in payment balance.
                                  <br />
                                  Debit - Amount debited from payment balance.
                                </Tooltip>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.paymentBalanceBreakUp.length > 0 ? (
                              this.state.paymentBalanceBreakUp.map(
                                (history, index) => (
                                  <tr key={index}>
                                    <td>
                                      {history.status === "pending" ? (
                                        <span
                                          style={{
                                            marginRight: "5px",
                                          }}
                                        >
                                          ?
                                        </span>
                                      ) : history.status === "credit" ? (
                                        <span
                                          style={{
                                            color: "#26ab2b",
                                            marginRight: "5px",
                                          }}
                                        >
                                          +
                                        </span>
                                      ) : (
                                        <span
                                          style={{
                                            color: "red",
                                            fontSize: "20px",
                                            marginRight: "5px",
                                          }}
                                        >
                                          -
                                        </span>
                                      )}
                                      {history.amount.toFixed(2) || "0"}
                                    </td>
                                    <td>
                                      <div className="d-flex">
                                        {history.note || "-"}
                                      </div>
                                    </td>
                                    <td>
                                      {moment
                                        .utc(history.createdAt)
                                        .format("MM-DD-YYYY") || "-"}
                                    </td>
                                    <td>
                                      {history.status
                                        ? capitalizeFirstLetter(history.status)
                                        : "-"}
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td
                                  // style={{ height: "2000px" }}
                                  colSpan="4"
                                  className="text-center"
                                >
                                  No payment balance history found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </TabPanel>
                    </Tabs>
                  </Row>
                </CardBody>
                {this.state.ImageModel && (
                  <Lightbox
                    mainSrc={this.state.imageUrl}
                    onCloseRequest={() => this.setState({ ImageModel: false })}
                  />
                )}
                {this.state.dueAmountBreakUpModal ? (
                  <Modal
                    isOpen={this.state.dueAmountBreakUpModal}
                    toggle={(event) => this.toggleDueAmountBreakUpModal()}
                    className="modal-lg"
                  >
                    <ModalHeader
                      toggle={(event) => this.toggleDueAmountBreakUpModal()}
                    >
                      Past Due Amount Break Up
                    </ModalHeader>
                    <ModalBody>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Amount</th>
                            <th>Note</th>
                            <th>Event Name</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.child.dueAmountBreakUp &&
                          this.state.child.dueAmountBreakUp.length ? (
                            this.state.child.dueAmountBreakUp.map(
                              (value, index) => (
                                <tr key={index}>
                                  <td>{value.amount.toFixed(2)}</td>
                                  <td>{value.note}</td>
                                  <td>
                                    {value.campName
                                      ? capitalizeFirstLetter(value.campName)
                                      : "-"}
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td
                                colSpan="5"
                                className="text-center"
                                style={{ background: "#dee2e6" }}
                              >
                                All past due amount processed
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </ModalBody>
                  </Modal>
                ) : null}
                {this.state.creditAmountBreakUpModal ? (
                  <Modal
                    isOpen={this.state.creditAmountBreakUpModal}
                    toggle={(event) => this.toggleCreditAmountBreakUpModal()}
                    className="modal-lg"
                  >
                    <ModalHeader
                      toggle={(event) => this.toggleCreditAmountBreakUpModal()}
                    >
                      Credit Amount Break Up
                    </ModalHeader>
                    <ModalBody>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Amount</th>
                            <th>Note</th>
                            <th>Event Name</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.child.creditAmountBreakUp &&
                          this.state.child.creditAmountBreakUp.length ? (
                            this.state.child.creditAmountBreakUp.map(
                              (value, index) => (
                                <tr key={index}>
                                  <td>{value.amount.toFixed(2)}</td>
                                  <td>{value.note}</td>
                                  <td>
                                    {value.campName
                                      ? capitalizeFirstLetter(value.campName)
                                      : "-"}
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td
                                colSpan="5"
                                className="text-center"
                                style={{ background: "#dee2e6" }}
                              >
                                All credit amount processed
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </ModalBody>
                  </Modal>
                ) : null}
                {this.state.cardViewModal ? (
                  <Modal
                    isOpen={this.state.cardViewModal}
                    toggle={(event) => this.toggleCardViewModal()}
                    className="modal-md"
                  >
                    <ModalHeader toggle={(event) => this.toggleCardViewModal()}>
                      Credit Card Details
                    </ModalHeader>
                    <ModalBody>
                      <Row
                        style={
                          this.state.addCardCollapse
                            ? {
                                borderBottom: "1px solid #dee2e6",
                                marginBottom: "10px",
                              }
                            : null
                        }
                      >
                        <Col>
                          <Button
                            id="toggler"
                            className="float-right mb-2"
                            onClick={() => {
                              this.setState({
                                addCardCollapse: !this.state.addCardCollapse,
                              });
                            }}
                          >
                            Add Credit Card
                          </Button>
                        </Col>
                      </Row>
                      <UncontrolledCollapse
                        toggler="#toggler"
                        isOpen={this.state.addCardCollapse}
                      >
                        <Form className="form" onSubmit={this.addCreditCard}>
                          <Row style={{ padding: "0px 15px" }}>
                            <Col style={{ margin: "auto" }}>
                              <Cards
                                cvc={this.state.cvc}
                                expiry={this.state.expiry}
                                focused={this.state.focus}
                                name={this.state.name}
                                number={this.state.number}
                                callback={(event) => {
                                  this.setState({ cardType: event.issuer });
                                }}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col className="mt-3">
                              <Label>Select Adult</Label>
                              <Select
                                placeholder="Select the Adult"
                                value={this.state.selectedAdult}
                                options={this.state.allAdultsOptions}
                                onChange={(result) =>
                                  this.setState({
                                    selectedAdult: result,
                                  })
                                }
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col className="mt-3">
                              <>
                                <Label>Card Number</Label>
                                <FormGroup>
                                  <Input
                                    id="number"
                                    name="number"
                                    type="text"
                                    maxLength="16"
                                    value={this.state.number}
                                    onChange={(event) =>
                                      this.setState({
                                        number: event.target.value,
                                        focus: "number",
                                      })
                                    }
                                    placeholder="CARD NUMBER"
                                    required
                                  />
                                </FormGroup>
                              </>
                              <>
                                <Label>Card Name</Label>
                                <FormGroup>
                                  <Input
                                    id="name"
                                    name="name"
                                    type="text"
                                    value={this.state.name}
                                    onChange={(event) =>
                                      this.setState({
                                        name: event.target.value,
                                        focus: "name",
                                      })
                                    }
                                    placeholder="CARD NAME"
                                    required
                                  />
                                </FormGroup>
                              </>
                              <Row>
                                <Col xl={6} lg={6} md={12} sm={12}>
                                  <Label>Card Expiration Date</Label>
                                  <FormGroup>
                                    <Input
                                      id="expiry"
                                      name="expiry"
                                      type="text"
                                      maxLength="4"
                                      value={this.state.expiry}
                                      onChange={(event) =>
                                        this.setState({
                                          expiry: event.target.value,
                                          focus: "expiry",
                                        })
                                      }
                                      placeholder="MM/YY"
                                      required
                                    />
                                  </FormGroup>
                                </Col>
                                <Col xl={6} lg={6} md={12} sm={12}>
                                  <Label>CVC</Label>
                                  <FormGroup>
                                    <Input
                                      id="cvc"
                                      name="cvc"
                                      type="text"
                                      maxLength="4"
                                      value={this.state.cvc}
                                      onChange={(event) =>
                                        this.setState({
                                          cvc: event.target.value,
                                          focus: "cvc",
                                        })
                                      }
                                      placeholder="CVC"
                                      required
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <>
                                <FormGroup>
                                  <Button type="submit" onClick={() => {}}>
                                    Add Credit Card
                                  </Button>
                                </FormGroup>
                              </>
                            </Col>
                          </Row>
                        </Form>
                      </UncontrolledCollapse>
                      <Table striped hover responsive>
                        <thead>
                          <tr>
                            <th className={"text-center"}>Adult Name</th>
                            <th className={"text-center"}>Card Number</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.stripeCards.length ? (
                            this.state.stripeCards.map((card, index) => (
                              <tr key={index}>
                                <td className={"text-center"}>
                                  {card.name ? card.name : "-"}
                                </td>
                                <td className={"text-center"}>
                                  {card.number ? card.number : "-"}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3" className="text-center">
                                No cards found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </ModalBody>
                  </Modal>
                ) : null}
                {this.state.bankViewModal ? (
                  <Modal
                    isOpen={this.state.bankViewModal}
                    toggle={(event) => this.toggleBankViewModal()}
                    className="modal-md"
                  >
                    <ModalHeader toggle={(event) => this.toggleBankViewModal()}>
                      Bank Account Details
                    </ModalHeader>
                    <ModalBody>
                      <Row
                        style={
                          this.state.addBankCollapse
                            ? { borderBottom: "1px solid #dee2e6" }
                            : null
                        }
                      >
                        <Col>
                          <Button
                            id="toggler1"
                            className="float-right mb-2"
                            onClick={() => {
                              this.setState({
                                viewError: false,
                                addBankCollapse: !this.state.addBankCollapse,
                              });
                            }}
                          >
                            Add an ACH debit bank account
                          </Button>
                        </Col>
                      </Row>
                      <UncontrolledCollapse
                        toggler="#toggler1"
                        isOpen={this.state.addBankCollapse}
                      >
                        <Form className="form" onSubmit={this.addBankAccount}>
                          <Row>
                            <Col className="mt-3">
                              <Label>Select Adult</Label>
                              <Select
                                placeholder="Select the Adult"
                                value={this.state.selectedAdult}
                                options={this.state.allAdultsOptions}
                                onChange={(result) =>
                                  this.setState({
                                    selectedAdult: result,
                                  })
                                }
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col className="mt-3">
                              <>
                                <Label>Account holder name</Label>
                                <FormGroup>
                                  <Input
                                    id="account_holder_name"
                                    name="account_holder_name"
                                    type="text"
                                    value={this.state.account_holder_name}
                                    onChange={(event) =>
                                      this.setState({
                                        account_holder_name: event.target.value,
                                      })
                                    }
                                    placeholder="Account Holder Name"
                                    required
                                  />
                                </FormGroup>
                              </>
                              <>
                                <Label>Routing number</Label>
                                <FormGroup>
                                  <Input
                                    id="routing_number"
                                    name="routing_number"
                                    type="text"
                                    maxLength="9"
                                    value={this.state.routing_number}
                                    onChange={(event) =>
                                      this.setState({
                                        routing_number: event.target.value,
                                      })
                                    }
                                    placeholder="Routing Number"
                                    required
                                  />
                                </FormGroup>
                              </>
                              <>
                                <Label>Account number</Label>
                                <FormGroup>
                                  <Input
                                    id="account_number"
                                    name="account_number"
                                    type="text"
                                    maxLength="12"
                                    value={this.state.account_number}
                                    onChange={(event) =>
                                      this.setState({
                                        account_number: event.target.value,
                                      })
                                    }
                                    placeholder="Account Number"
                                    required
                                  />
                                </FormGroup>
                              </>
                              <>
                                <Label>Confirm account number</Label>
                                <FormGroup>
                                  <Input
                                    id="confirm_account_number"
                                    name="confirm_account_number"
                                    type="text"
                                    maxLength="12"
                                    style={
                                      this.state.viewError &&
                                      this.state.account_number !==
                                        this.state.confirm_account_number
                                        ? { border: "1px solid rgb(224 66 66)" }
                                        : null
                                    }
                                    value={this.state.confirm_account_number}
                                    onChange={(event) =>
                                      this.setState({
                                        viewError: true,
                                        confirm_account_number:
                                          event.target.value,
                                      })
                                    }
                                    placeholder="Confirm Account Number"
                                    required
                                  />
                                </FormGroup>
                                {this.state.viewError &&
                                this.state.account_number !==
                                  this.state.confirm_account_number ? (
                                  <Label style={{ color: "rgb(224 66 66)" }}>
                                    <BsFillExclamationTriangleFill className="mr-1"></BsFillExclamationTriangleFill>
                                    Your account numbers don't match.
                                  </Label>
                                ) : null}
                              </>
                              <>
                                <FormGroup>
                                  <Button type="submit" onClick={() => {}}>
                                    Add ACH debit bank account
                                  </Button>
                                </FormGroup>
                              </>
                            </Col>
                          </Row>
                        </Form>
                      </UncontrolledCollapse>
                      <Table striped hover responsive>
                        <thead>
                          <tr>
                            <th className={"text-center"}>Adult Name</th>
                            <th className={"text-center"}>Name</th>
                            <th className={"text-center"}>Routing Number</th>
                            <th className={"text-center"}>Account Number</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.bankAccounts.length ? (
                            this.state.bankAccounts.map(
                              (bankAccount, index) => (
                                <tr key={index}>
                                  <td className={"text-center"}>
                                    {bankAccount.name ? bankAccount.name : "-"}
                                  </td>
                                  <td className={"text-center"}>
                                    {bankAccount.account_holder_name
                                      ? bankAccount.account_holder_name
                                      : "-"}
                                  </td>
                                  <td className={"text-center"}>
                                    {bankAccount.routing_number
                                      ? bankAccount.routing_number
                                      : "-"}
                                  </td>
                                  <td className={"text-center"}>
                                    {bankAccount.account_number
                                      ? bankAccount.account_number
                                      : "-"}
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan="5" className="text-center">
                                No bank accounts found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </ModalBody>
                  </Modal>
                ) : null}
              </Card>
            </Col>
          </Row>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
export default RushUserPlayerDetails;
